<template>
    <div>
        <el-table
                :data="orderSettlementInvoices"
                size="medium"
                style="width: 100%">
            <el-table-column
                    type="selection"
                    >
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="套餐名"
                    >
            </el-table-column>
            <el-table-column
                    label="总价"
            >
                <template slot-scope="scope">
                    <span >{{scope.row.sum_price|currency('￥',2)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template slot-scope="scope">
                    <el-dropdown trigger="click" size="medium">
                        <el-button icon="el-icon-edit" style="margin-right: 10px"> 编辑</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleDetail(scope.row.id)">查看详情</el-dropdown-item>
<!--                            <el-dropdown-item @click.native="handleDelete(scope.row)">删除</el-dropdown-item>-->
                            <el-dropdown-item @click.native="handleRollback(scope.row.id)" v-if="scope.row.channel=='xuezhi'">回退购物车</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                settlementInvoices: [],
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowSettlementInvoices();
        },
        computed: {
            orderSettlementInvoices: function () {
                return this._.values(this.$parentInfo.NoSettlementInvoice.settlementInvoices);
            },
        },
        methods: {
            handleShowSettlementInvoices() {
                this.$wApi.send(this.$parentInfo.path, 'get_settlementInvoice', {
                    'student_id': this.$parentInfo.student_id,
                })
            },
            handleDetail(settlement_invoice_id){
                this.$Win.openModal('Dialog_SettlementInvoiceDetail', 900, 500, '详情', {
                    'settlement_invoice_id':settlement_invoice_id,
                });
            },
            handleDelete(){

            },
            handleRollback(settlement_invoice_id){
                this.$confirm('确认回退?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'return_settlementInvoice_to_carts', {
                        'settlement_invoice_id': settlement_invoice_id,
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>